
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 14.602h3.441V9.43c0-.696-.529-1.26-1.182-1.26H1.182C.529 8.17 0 8.735 0 9.43v5.172zM5.185 14.602h3.441V5.524c0-.696-.529-1.26-1.181-1.26h-1.08c-.652 0-1.181.564-1.181 1.26v9.078zM11.55 0c-.653 0-1.183.564-1.183 1.26v13.343h3.442V1.26c0-.696-.53-1.26-1.183-1.26H11.55z","fill":"#E2E8F0"}})])
          )
        }
      }
    